import { AnchorHTMLAttributes } from 'react'
import {
  BackgroundProps,
  BorderProps,
  ColorProps,
  DisplayProps,
  FlexboxProps,
  GridProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system'

import { TestIdProps, TextDecorationProps } from 'designSystem/types/propTypes'

import INTERNALxAnchor from '../internal/elements/INTERNALxAnchor'

type BaseProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  BackgroundProps &
  BorderProps &
  ColorProps &
  DisplayProps &
  FlexboxProps &
  GridProps &
  LayoutProps &
  PositionProps &
  ShadowProps &
  SpaceProps &
  TestIdProps &
  TextDecorationProps &
  TypographyProps

type Props = {
  to?: string
} & BaseProps

export default function PDSLinkWrapper({ testId, to, ...props }: Props) {
  return <INTERNALxAnchor href={to} testId={testId} {...props} />
}
